export default {
  slug: "clion-nova",
  code: "CLN",
  label: "CLion Nova",
  logoFamily: "jb",
};
